import { ReactNode } from "react";
import { InfoBanner } from "./InfoBanner";

interface AdminContentHeaderProps {
  title: string;
  subtitle?: string;
  banner?: {
    message: string;
    variant?: "info" | "warning" | "success" | "error";
  };
  actions?: ReactNode;
}

export const AdminContentHeader = ({
  title,
  subtitle,
  banner,
  actions,
}: AdminContentHeaderProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
          {subtitle && (
            <p className="text-muted-foreground mt-1">{subtitle}</p>
          )}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      
      {banner && (
        <InfoBanner message={banner.message} variant={banner.variant} />
      )}
    </div>
  );
};
